import _esWeakSet from "../modules/es.weak-set.constructor";
// TODO: Remove this module from `core-js@4` since it's replaced to module below
_esWeakSet;
export default {};